import styled from "styled-components";

export const Image = styled.img`
width: 350px;
border-radius: 50px;
margin-top: 15%;
`;

export const Box = styled.div`
width: 350px;
height: 115%;
border-radius: 30px;
background-color: #fff;
margin-top: -20%;
margin-bottom: 10%;
-webkit-box-shadow: 0px 0px 29px 0px rgba(0,0,0,0.2);
-moz-box-shadow: 0px 0px 29px 0px rgba(0,0,0,0.2);
box-shadow: 0px 0px 29px 0px rgba(0,0,0,0.2);
`;

export const Title = styled.h1`
text-align: center;
color: #1476C6;
font-size: 36px;
margin-top: 3%;
`;

export const Description = styled.p`
color: #5F5F5F;
font-size: 14px;
font-weight: 500;
margin-top: 3%;
width: 300px;
`;